"use strict";

import axios from "axios";
import Vue from "vue";
import loggingService from "../services/LoggingService";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    const companyOauth = localStorage.getItem("companyOauth") || "google";

    if (companyOauth === "microsoft") {
      if (
        config.url.includes("/signature/batch") ||
        config.url.includes("/vacation/batch") ||
        config.url.includes("/tags/batch") ||
        config.url.includes("/delegate") ||
        config.url.includes("/upload-image") ||
        config.url.includes("/client/scopes") ||
        config.url.includes("/user/update") ||
        config.url.includes("/installed") ||
        config.url.endsWith("/users/sync") ||
        /^\/user\/\d+\/vacation$/.test(config.url)
      ) {
        if (config.url.includes(":async")) {
          const url = config.url.replace(/(:)async/, "/ms$1async");
          config.url = url;
        } else {
          config.url = `${config.url}/ms`;
        }
      }
    }

    config.metadata = { startTime: new Date() };
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // const endTime = new Date();
    // const duration = endTime - response.config.metadata.startTime;

    // loggingService.logEvent("api_request", {
    //   url: response.config.url,
    //   method: response.config.method,
    //   status: response.status,
    //   duration,
    // });

    return response;
  },
  function (error) {
    // Do something with response error
    loggingService.logError("network", error, {
      url: error.config.url,
      method: error.config.method,
      status: error.response?.status,
      status_text: error.response?.statusText,
      error_code: error.response?.data?.code,
    });
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
